<template>
  <div>
    <div>
      <div
        class="message-marked"
        v-html="parsedContent"
      />
    </div>
  </div>
</template>

<script lang="ts">
import vue  from '../../../../../../adapter-vue';
import { parseMarkdown } from "./marked";
import { customerServicePayloadType } from '../../../../../../interface';
const { computed } = vue;
interface Props {
  payload: customerServicePayloadType;
}
export default {
  components: {},
  props: {
    payload: {
      type: Object as () => customerServicePayloadType,
      default: () => ({}),
    },
  },
  emits: ['heightChanged', 'previewImage'],
  setup(props: Props, { emit }) {
    const parsedContent = computed(() => {
      // @ts-ignore
      window.onMarkdownImageClicked = function(href: string) {
        emit('previewImage', decodeURIComponent(href));
      }
      // @ts-ignore
      window.onMarkdownMediaLoad = function() {
        emit('heightChanged');
      }
      return parseMarkdown(props.payload.content);
    });

    return {
      props,
      parsedContent,
    };
  },
};
</script>
<style lang="scss">
.message-video {
  position: relative;
  display: flex;
  justify-content: center;
  overflow: hidden;

  &-box {
    max-width: min(calc(100vw - 180px), 300px);
    font-size: 0;

    video {
      max-width: min(calc(100vw - 180px), 300px);
      max-height: min(calc(100vw - 180px), 300px);
      width: inherit;
      height: inherit;
    }
  }
}
.dialog-video {
  position: fixed;
  z-index: 12;
  width: 100vw;
  height: 100vh;
  top: 0;
  left: 0;
  display: flex;
  flex-direction: column;
  align-items: center;

  &-close {
    display: flex;
    justify-content: flex-end;
    background: #000;
    width: 100%;
    box-sizing: border-box;
    padding: 10px;
  }

  &-box {
    display: flex;
    flex: 1;
    max-height: 100%;
    padding: 6rem;
    box-sizing: border-box;
    justify-content: center;
    align-items: center;

    video {
      max-width: 100%;
      max-height: 100%;
    }
  }
}

.message-marked .image-container {
  -webkit-tap-highlight-color: transparent;
}
</style>
